import { z } from "zod";

import { matchAndClubCountryCodes } from "./countries";
import { playerFFTranking, playerGenders } from "./enums";
import { ATPRankingBrackets, ITFRankingBrackets, UTRRankingBrackets } from "./ranking-brackets";

// Critères de la simulation de recherche offerte aux clubs freemium. L'API n'en
// renvoie qu'un décompte : aucun profil ne sort de la base par ce chemin.
//
// Tous les critères sont des valeurs fermées (énumérations connues du client).
// Pas de champ libre, en particulier pas de recherche par nom : un décompte
// renvoyé sur un nom saisi confirmerait la présence d'une personne en base.
export const playerSearchFiltersSchema = z.object({
  country: z.enum(matchAndClubCountryCodes).nullish(),
  gender: z.enum(playerGenders).nullish(),
  FFTRanking: z.enum(playerFFTranking).nullish(),
  UTRBracket: z.enum(UTRRankingBrackets).nullish(),
  ATPBracket: z.enum(ATPRankingBrackets).nullish(),
  ITFBracket: z.enum(ITFRankingBrackets).nullish(),
});

export type PlayerSearchFilters = z.infer<typeof playerSearchFiltersSchema>;
